export default "__VITE_PUBLIC_ASSET__b9d9caca__"